__turbopack_context__.v({
  "button": "index-module-scss-module__UB8gaa__button",
});
